var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContent',[_c('div',[_c('ModernTable',{attrs:{"region":_vm.region,"filters":_vm.filters,"rows":_vm.rows,"columns":_vm.columns,"pagination":{
        perPage: 12
      },"loading":_vm.loading}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }